<template>
    <span>
        <div :class="'list-post-counter ' + (this.mainclass ? this.mainclass : '')">
            <div v-if="isFavorited" @click.prevent="unFavorite(store)">
                <span>{{ this.faveCount > 0 ? this.faveCount : "0" }}</span>
                <i class="fa fa-heart"></i>
            </div>
            <div v-else @click.prevent="favorite(store)">
                <span>{{ this.faveCount > 0 ? this.faveCount : "0" }}</span>
                <i class="fa fa-heart-o" aria-hidden="true"></i>
            </div>
        </div>
    </span>
</template>

<script>
    export default {
        props: ['store', 'favorited', 'count', 'loggedin', 'mainclass'],

        data: function() {
            return {
                isFavorited: '',
                faveCount: this.count,
                loggedIn: this.loggedin
            }

        },
        mounted() {
            this.isFavorited = this.isFavorite ? true : false;
        },
        computed: {
            isFavorite() {
                return this.favorited;
            },
        },

        methods: {
            favorite(store) {
                if (this.loggedIn === 1) {
                    axios.post('/favorite/' + store)
                        .then(
                            response => this.isFavorited = true,
                            this.faveCount = this.faveCount + 1
                        )
                        .catch(response => console.log(response.data));
                } else {
                    swal({
                        title: "Sorry",
                        text: "You must be signed in to add stores to your favourites",
                        type: "warning",
                        timer: 2000,
                        showConfirmButton: false
                    });
                    //$('.reg-btn .modal-trigger').click();
                }
            },
            unFavorite(store) {
                if (this.loggedIn === 1) {
                axios.post('/unfavorite/'+store)
                    .then(
                        response => this.isFavorited = false,
                        this.faveCount = this.faveCount-1
                    )
                    .catch(response => console.log(response.data));
                } else {
                    swal({
                        title: "Sorry",
                        text: "You must be signed in to add stores to your favourites",
                        type: "warning",
                        timer: 2000,
                        showConfirmButton: false
                    });
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Favorite.vue